import { ReactElement, useMemo } from 'react';
import {
  TSelectedGamesConfigs,
  TSelectedGamesProps
} from 'interfaces/selected-games';
import { SelectedGames } from 'components/SelectedGames';

export const SelectedSport = (props: TSelectedGamesProps): ReactElement => {
  const updatedConfigs = useMemo<TSelectedGamesConfigs>(() => {
    if (!props.configs.imgPath) {
      return props.configs;
    }

    try {
      const parsedImagePaths =
        typeof props.configs.imgPath === 'string'
          ? JSON.parse(props.configs.imgPath)
          : props.configs.imgPath;

      return {
        ...props.configs,
        imgPath: parsedImagePaths
      };
    } catch (_) {
      return props.configs;
    }
  }, [props.configs]);

  return <SelectedGames configs={updatedConfigs} />;
};
